import { render, staticRenderFns } from "./InterestFollowUpFilter.vue?vue&type=template&id=31f768d2&"
import script from "./InterestFollowUpFilter.vue?vue&type=script&lang=js&"
export * from "./InterestFollowUpFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports